import React from "react";
import "./LawPill.css";

export default function LawPill({ code, title, href }) {
  const className = "trunfo-law-pill";
  const content = (
    <>
      <span className="trunfo-law-pill__code">{code}</span>
      {title && <span className="trunfo-law-pill__title">{title}</span>}
    </>
  );

  if (href) {
    return (
      <a className={className} href={href} target="_blank" rel="noreferrer">
        {content}
      </a>
    );
  }

  return <span className={className}>{content}</span>;
}
